/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Solver_ForInputs */

const en_cp_solver_for = /** @type {(inputs: Cp_Solver_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capstone, applied-research grants, thematic community service, national ICT competitions, student-society hackathons.`)
};

const id_cp_solver_for = /** @type {(inputs: Cp_Solver_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capstone, PKM-KC/PM, KKN tematik, Gemastik, KMIPN, hackathon himpunan.`)
};

/**
* | output |
* | --- |
* | "Capstone, applied-research grants, thematic community service, national ICT competitions, student-society hackathons." |
*
* @param {Cp_Solver_ForInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_solver_for = /** @type {((inputs?: Cp_Solver_ForInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Solver_ForInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_solver_for(inputs)
	return en_cp_solver_for(inputs)
});